<script setup lang="ts">
import { computed } from 'vue';
import UiBadge, { type BadgeColor, type BadgeSize } from '@/modules/ui/components/ui/UiBadge.vue';

const { value } = defineProps<{
  value: number;
  size?: BadgeSize;
  color?: BadgeColor;
  pulse?: boolean;
}>();

const formatted = computed(() => (value > 99 ? '99+' : value));
</script>

<template>
  <UiBadge
    v-if="value > 0"
    class="reduced-badge"
    :value="formatted"
    :size="size"
    :color="color"
    :pulse="pulse"
  />
</template>
